import React from 'react';
import { useState, useEffect, useCallback } from "react";
import Gallery from "react-photo-gallery";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Carousel, { Modal, ModalGateway } from "react-images";
import * as symbols from '../../operations/symbols';

export const PhotoViewer = props => {
  const {
    photos,
    removeCross,
    showPhotoViewer,
    name,
    className,
    uploadImagesStatus
  } = props;

  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
  const [images, setImages] = useState([{ src: '' }]);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const setImagesState = (e, index) => {
    const images = props.photos.reduce((acc, ele) => {
      if (props.name === 'imageUrl') {
        acc.push({
          src: ele.imageUrl
        })
      } else {
        acc.push({
          src: URL.createObjectURL(ele)
        })
      }
      return acc
    }, [])
    setImages(images)
    setCurrentImage(index);
    setViewerIsOpen(true);
  }
  return (

    <React.Fragment>
      {/*<Gallery photos={props.photos} onClick={openLightbox} />*/}
      <div>
        {
          photos && photos.map((ele, index) => {
            return(
              <div className="order-photo-wrapper" key={index}>
                  {
                    removeCross ? 
                    null : 
                    <div className="cross-image" onClick={(e) => props.removeImage(e, index, props.photos, props.id)}>
                      <FontAwesomeIcon icon="times" />
                    </div>
                  }
                  {
                    showPhotoViewer ? 
                    <React.Fragment>
                      {
                        name === "imageUrl" ?
                        <div className={`gallery-item ${className}`} style={{'backgroundImage': 'url('+ele.imageUrl+')'}} onClick={(event) => setImagesState(event, index)}/> :
                        <div className={`gallery-item ${className}`} style={{'backgroundImage': 'url('+URL.createObjectURL(ele)+')'}} onClick={(event) => setImagesState(event, index)}/>
                      }
                    </React.Fragment> :
                    <React.Fragment>
                      {
                        name === "imageUrl" ?
                        <div className={`gallery-item ${className}`} style={{'backgroundImage': 'url('+ele.imageUrl+')'}} /> :
                        <div className={`gallery-item ${className}`} style={{'backgroundImage': 'url('+URL.createObjectURL(ele)+')'}} />
                      }
                    </React.Fragment>
                  }
                  
                  
             
              </div>
            )     
          })
        }
        <div className="order-photo-wrapper">
        {
          uploadImagesStatus === symbols.STATUS_BEGIN ?
          <div className="gallery-item order-photo-ele order-photo-placeholder" >
            <FontAwesomeIcon icon="spinner" className="animate-spinner"/>
        </div> :
        <div className="gallery-item order-photo-ele order-photo-placeholder" onClick={() => props.openPictureModeModal()}>
            <FontAwesomeIcon icon="camera"/>
        </div>
        }
        
        </div>
      </div>
      <ModalGateway className="z-highest">
        {viewerIsOpen ? (
          <Modal onClose={closeLightbox}>
            <Carousel
              currentIndex={currentImage}
              views={images.map(x => (
                {
                ...x,
                srcset: x.src
              }))}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    </React.Fragment>
  );
}


export const PhotoMainViewer = props => {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
  const [images, setImages] = useState([{ src: '' }]);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const setImagesState = (e, index) => {
    const images = props.photos.reduce((acc, ele) => {
      if (props.name === 'url') {
        acc.push({
          src: ele.url
        })
      } else {
        acc.push({
          src: ele.imageUrl
        })
      }
      return acc
    }, [])
    setImages(images)
    setCurrentImage(index);
    setViewerIsOpen(true);
  }

  return (
    <div>
      {/*<Gallery photos={props.photos} onClick={openLightbox} />*/}
      <div className={`gallery ${props.mainClassName ? props.mainClassName : ''}`}>
        {
          props.photos.map((ele, index) => {
            return(
               <div className="order-photo-wrapper" key={index}>
               {
                  props.name === 'url' ?
                  <div className={`gallery-item ${props.className}`} style={{'backgroundImage': 'url('+ele.url+')'}} onClick={(event) => setImagesState(event, index)}/>
                :
                  <div className={`gallery-item ${props.className}`} style={{'backgroundImage': 'url('+ele.imageUrl+')'}} onClick={(event) => setImagesState(event, index)}/>
               }
              </div>
            )     
          })
        }
      </div>
      <ModalGateway className="z-highest">
        {viewerIsOpen ? (
          <Modal onClose={closeLightbox}>
            <Carousel
              currentIndex={currentImage}
              views={images.map(x => (
                {
                ...x,
                srcset: x.src
              }))}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    </div>
  );
}
